import { ComponentConfigProps, FilterData } from "../typing";
import FilterItemBanks from "./Banks";
import FilterItemBrand from "./Brand";
import FilterItemCashRate from "./CashRate";
import FilterItemCertificates from "./Certificates";
import FilterItemDistance from "./Distance";
import FilterItemGRating from "./GRating";
import FilterPointsPrice from "./PointsPrice";
import FilterItemSubBrand from "./SubBrand";

/**
 * 注册的filter项目
 */
export const filterRegisterList: ComponentConfigProps[] = [
  {
    key: "brand",
    label: "Brands",
    component: FilterItemBrand,
    defaultValue: [],
  },
  {
    key: "subBrand",
    label: "Subbrands",
    component: FilterItemSubBrand,
    defaultValue: [],
  },
  {
    key: "banks",
    label: "Cards",
    component: FilterItemBanks,
    defaultValue: [],
  },
  {
    key: "pointsPrice",
    label: "Point Price",
    component: FilterPointsPrice,
    defaultValue: -1,
  },
  {
    key: "certificates",
    label: "Certificates",
    component: FilterItemCertificates,
    defaultValue: [],
  },
  {
    key: "distance",
    label: "Distance",
    component: FilterItemDistance,
    defaultValue: -1,
  },
  {
    key: "gRating",
    label: "Review",
    component: FilterItemGRating,
    defaultValue: 0,
  },
  {
    key: "cashRate",
    label: "Cash Price",
    component: FilterItemCashRate,
    defaultValue: -1,
  },
];

/**
 * 获取所有filter的默认值
 * @returns
 */
export const getFilterDefault = () => {
  return filterRegisterList.reduce((result, item) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    result[item.key] = item.defaultValue;
    return result;
  }, {} as FilterData);
};

export const getFilterConfigByKey = (key: string): ComponentConfigProps | undefined => {
  return filterRegisterList.find((item) => item.key === key);
};
